module.exports = __webpack_public_path__ + "img/selected3-min.7819bbd2.png";